import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../config/axions.config';
import Swal from 'sweetalert2'
import { toast } from 'sonner';
import { showDate } from '../../constant';

const EditFeesCollection = () => {
  let navigate = useNavigate();
  let location = useLocation();
  let data = location.state
  const [name, setName] = useState(data?.studentData.firstname + " " + data?.studentData.lastname)
  const [student_id, setStudent_Id] = useState(data?.student_id)
  const [total_amount, setTotal_amount] = useState(data?.total_amount)
  const [payment_date, setPayment_date] = useState(data?.payment_date.split("T")[0])
  const [installment, setInstallment] = useState(data?.installment)
  const [payment_type, setPayment_type] = useState(data?.paymentType.type);
  const [payment_typeId, setPayment_typeId] = useState(data?.paymentType._id);
  const [payment_typeList, setPayment_typeList] = useState([]);
  const [contact, setContact] = useState(data?.studentData.mobile);
  const [admissionTypeList, setAdmissionTypeList] = useState([])
  const [admission_type, setAdmission_type] = useState(data?.AdmissionData.type)
  const [total_fee, setTotal_fee] = useState();
  const [courseList, setCourseList] = useState([])
  const [courses, setCourses] = useState(data?.courseData.name)
  const [feesCollectionActive,setFeesCollectionActive] = useState(data?.is_active)
  const [file, setFile] = useState(); 
  const [transactionID, setTransactionID] = useState(data?.transactionID);
  const [enrolment_id, setEnrolment_id] = useState(data?.enrolment_id);


  async function getCourseList() {
    try {
      let responce = await api.get("course")
      if (responce?.data.status) {
        setCourseList(responce.data.data.courses);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }


  function setCourse(e) {
    /* setCourse_id(e.target.value);
    setTutor(e.target.selectedOptions[0].getAttribute('tutor'));
    setDuration(e.target.selectedOptions[0].getAttribute('duration')); */
    setTotal_fee(e.target.selectedOptions[0].getAttribute('total_fee'))
  }

  async function getPaymentType() {
    try {
      let responce = await api.get("paymentType")
      if (responce?.data.status) {
        setPayment_typeList(responce.data.data.PaymentTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getAdmissionType() {
    try {
      let responce = await api.get("admissionType")
      if (responce?.data.status) {
        setAdmissionTypeList(responce.data.data.AdmissionTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function updateFeesCollection() {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this?!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Update it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        let responce = await api.patch(`feecollection/${data._id}`, { student_id, total_amount, payment_date, payment_type:payment_typeId, installment, enrolment_id, is_active:feesCollectionActive })
        if (responce.data.status) {
          toast.success(responce.data.message);
        } else {
          toast.error(responce.data.message);
        }
      } else {
        toast.error("OK! request cancle.")
      }
    });
  }
  useEffect(() => {
    getPaymentType();
    getAdmissionType();
    getCourseList();
  }, [])

  function handleChange(e) {
    setFile(URL.createObjectURL(e.target.files[0]));
}
  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56'>
      <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
        <nav className="sm:hidden" aria-label="Back">
          <div className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
            <svg className="flex-shrink-0 w-5 h-5 mr-1 -ml-1 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            Back
          </div>
        </nav>

        <nav className="hidden sm:flex" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-4">
            <li>
              <div>
                <div className="text-gray-400 hover:text-gray-500">
                  <svg className="flex-shrink-0 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                  </svg>
                  <span className="sr-only">Home</span>
                </div>
              </div>
            </li>

            <li>
              <div className="flex items-center">
                <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <div className="ml-4 text-sm text-gray-500 hover:text-gray-700" onClick={() => navigate('/dashboard/fees-collection/')}>
                  Fees Collection
                </div>
              </div>
            </li>

            <li>
              <div className="flex items-center">
                <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <div className="ml-3 text-sm text-gray-500 hover:text-gray-700" aria-current="page">
                  Edit Collection
                </div>
              </div>
            </li>
          </ol>
        </nav>

        <hr className="my-5 border-gray-300" />

        <div className="lg:flex lg:items-center lg:space-x-8">
          <div className="lg:flex-1 lg:min-w-0">
            <h1 className="text-2xl font-semibold text-primary-600">
              Edit Fees Collection
            </h1>
            <div className="mt-2 md:mt-3 sm:flex sm:items-center sm:space-x-6">
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                  <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                  <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                </svg>
                <span className="text-gray-600">
                  Collection Id
                </span>
              </div>

              <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                  <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                  <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                </svg>
                <span className="text-gray-600">
                  Started - {showDate(data.created_at)}
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center mt-5 ml-auto space-x-6 lg:justify-end lg:mt-0 lg:flex-shrink-0">
            <div className="flex items-center space-x-2">
              <label htmlFor="">
                Collection Status
              </label>
              <div className="toggle-switch">
                <input type="checkbox" id="toggleSwitch" checked={feesCollectionActive} onChange={()=>setFeesCollectionActive(!feesCollectionActive)} value={true} />
                <label htmlFor="toggleSwitch"></label>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 space-y-6">
          <div className="bg-white rounded-lg shadow">
            <div className="px-4 py-3 sm:px-6">
              <div className="flex items-center -ml-2">
                <div title="Back" className="btn-circle" aria-label="Back" data-microtip-position="top" data-target="tooltip" role="button" onClick={() => navigate('/dashboard/fees-collection/')}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                  </svg>
                </div>

                <h2 className="ml-2 text-lg font-medium leading-6 text-gray-900">
                  Edit Collection
                </h2>
              </div>
            </div>

            <div className="px-4 py-5 border-t border-gray-300 sm:px-6">
              <form action={updateFeesCollection}>
                <div className='grid grid-cols-3 sm:grid-cols-3 gap-x-5 gap-y-4'>
                  <div className="col-span-1 sm:col-span-3 md:col-span-1">
                    <label htmlFor="">
                      Student Name <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <input type="text" value={name} onChange={(e) => setName(e.target.value)} name="" id="" placeholder="" className="" required />
                    </div>
                  </div>

                  <div className="col-span-1 sm:col-span-3 md:col-span-1">
                    <label htmlFor="">
                      Student Id <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <input type="text" value={student_id} onChange={(e) => setStudent_Id(e.target.value)} name="" id="" placeholder="" className="" required />
                    </div>
                  </div>

                  <div className="col-span-1 sm:col-span-3 md:col-span-1">
                    <label htmlFor="">
                      Contact No. <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <input type="number" value={contact} onChange={(e) => setContact(e.target.value)} name="" id="" placeholder="" className="" required />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-5 gap-y-4">
                  <div className="col-span-2 sm:col-span-4 md:col-span-2">
                    <label htmlFor="">
                      Admission Type <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <select onChange={(e) => { setAdmission_type(e.target.value) }} >
                        <option value={null}>
                          {admission_type}
                        </option>
                        {
                          admissionTypeList?.map(item => (
                            <option key={item._id} value={item._id}>
                              {item.type}
                            </option>
                          ))
                        }
                      </select>
                    </div>
                  </div>

                  <div className="col-span-2 sm:col-span-4 md:col-span-2">
                    <label htmlFor="">
                      Course <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <select onChange={(e) => setCourse(e)} >
                        <option value={null}>
                          {courses}
                        </option>
                        {
                          courseList?.filter((item) => item.admissionType === admission_type)?.map(item => (
                            <option key={item._id} value={item._id} tutor={item.tutor} duration={item.duration} total_fee={item.base_fee} >
                              {item.name}
                            </option>
                          ))
                        }
                      </select>
                    </div>
                  </div>

                  <div className="col-span-2 sm:col-span-4 md:col-span-2">
                      <div className='grid grid-cols-2 sm:grid-cols-4 gap-x-5 gap-y-4'>
                        <div className="col-span-2 sm:col-span-4 md:col-span-2">
                          <label htmlFor="">
                            Payment Type <span className="text-primary-600">*</span>
                          </label>
                          <div className="mt-1">
                            <select onChange={(e) => setPayment_type(e.target.value)} >
                              <option value={null}>
                                {payment_type}
                              </option>
                              {
                                payment_typeList?.filter((item) => item.is_active === true)?.map(item => (
                                  <option key={item._id} value={item._id}>
                                    {item.type}
                                  </option>
                                ))
                              }
                            </select>
                          </div>
                        </div>
                        <div className="col-span-2 sm:col-span-4 md:col-span-2">
                          <label htmlFor="">
                            Payment Date <span className="text-primary-600">*</span>
                          </label>
                          <div className="mt-1">
                            <div className="relative rounded-md shadow-sm">
                              <input type="date" value={payment_date} onChange={(e)=>setPayment_date(e.target.value)} name="" id="" placeholder="" className="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  <div className="col-span-2 sm:col-span-4 md:col-span-2">
                    <label htmlFor="">
                      Total Amount <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <div className="relative rounded-md shadow-sm">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <span className="text-gray-500 sm:text-sm">
                            &#8377;
                          </span>
                        </div>
                        <input type="number" value={total_amount} onChange={(e) => setTotal_amount(e.target.value)} name="" id="" placeholder="" className="!pl-7 !pr-12" required />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <span className="text-gray-500 sm:text-sm">
                            RS
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-span-2 sm:col-span-4 md:col-span-2">
                      <label htmlFor="">
                        Installments <span className="text-primary-600">*</span>
                      </label>
                      <div className="mt-1">
                        <input type="text" value={installment} onChange={(e)=>setInstallment(e.target.value)} name="" id="" placeholder="" className="" required />
                      </div>
                    </div>

                  <div className="col-span-2 sm:col-span-4 md:col-span-2">
                      <label htmlFor="">
                        Upload Screenshot
                      </label>
                      <div className="mt-1">
                        <div className='flex'>
                          <input type="file" className='' onChange={handleChange} />
                          <img src={file} alt='Screenshot' className='w-1/6'/>
                        </div>
                      </div>
                    </div>

                    <div className="col-span-2 sm:col-span-4 md:col-span-2">
                      <label htmlFor="">
                        Transaction Id
                      </label>
                      <div className="mt-1">
                        <input type="text" value={transactionID}  onChange={(e) => setTransactionID(e.target.value)} name="" id="" placeholder="" className="" />
                      </div>
                    </div>
                  </div>

                <div className="flex items-center justify-end mt-5 space-x-4">
                  <button type="button" className="btn btn-light" onClick={() => navigate('/dashboard/fees-collection/')}>
                    Back
                  </button>

                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditFeesCollection
